import { render, staticRenderFns } from "./WizardHeader.vue?vue&type=template&id=7a919517&scoped=true&lang=html&"
import script from "./WizardHeader.vue?vue&type=script&lang=js&"
export * from "./WizardHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a919517",
  null
  
)

export default component.exports